export const useAdminTools = () => useState<boolean>('admin-tools', () => (false))
